import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import { catchError, map, mergeMap, take } from 'rxjs/operators';
import { GovernmentAPIService } from '../../core/api';
import * as GlobalActions from './global.actions';

@Injectable()
export class GlobalEffects {
  readonly loadGlobal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GlobalActions.LoadGlobalConst),
      mergeMap(() =>
        combineLatest([this.governmentSvc.getVatCountries()]).pipe(
          take(1),
          map(([vatCountries]) =>
            GlobalActions.LoadGlobalConstSuccess({
              data: {
                vatCountries,
              },
            }),
          ),
          catchError((error) =>
            of(GlobalActions.LoadGlobalConstFailure({ error })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private governmentSvc: GovernmentAPIService,
  ) {}
}
